import { z } from 'zod';
/**
 * The three end-user packages, in ascending order. Mirrors the plans on
 * foundry.aldemis.com (Start / Build / Scale). Each tier's numbers — monthly
 * development-hour allowance, call limits, available call types — are
 * configurable data (see the `tier_config` table), not hard-coded here.
 */
export const TIERS = ['start', 'build', 'scale'];
export const tierSchema = z.enum(TIERS);
/** Human label for a tier. */
export function tierLabel(tier) {
    return tier.charAt(0).toUpperCase() + tier.slice(1);
}
/** A tier's position in the ascending order, for comparing plans. */
export function tierRank(tier) {
    return TIERS.indexOf(tier);
}
/** Whether moving from `from` to `to` is an upgrade, a downgrade, or the same plan. */
export function tierDirection(from, to) {
    const delta = tierRank(to) - tierRank(from);
    return delta > 0 ? 'upgrade' : delta < 0 ? 'downgrade' : 'same';
}
//# sourceMappingURL=tiers.js.map